/* Stylesheet */

.content_container {
  padding: 0;
  margin: 21px 0px 21px 0px;
  height: 80%;

  .letter_row {
    padding: 0;
    height: 52px;

    .col {
      padding: 0;
    }

    .letter_container {
      display: flex;
      height: 100%;
      width: 100%;
      align-items: center;
      justify-content: center;
      color: var(--ion-color-text-secondary);

      .letter {
        font-size: 1.5rem;
        font-weight: 500;
      }
    }
  }

  .content_row {
    height: 100%;
    border-radius: 8px;

    .col {
      padding: 21px;
    }
  }
}
